import { generatePagerDutyId } from '../../util/general';

const createIncidentData = (params) => {
  const incidentId = generatePagerDutyId();
  const serviceId = params.service.id;
  const assignneId = generatePagerDutyId();
  const escalationPolicyId = generatePagerDutyId();

  return {
    incident: {
      incident_number: 1,
      title: params.title || '',
      description: params.description || '',
      created_at: '2019-05-10T23:19:15Z',
      status: 'triggered',
      incident_key: '46737e0c4e6247af8e9467a07b3b8404',
      service: {
        id: serviceId,
        type: 'service_reference',
        summary: 'Sample Notification Service',
        self: `https://api.pagerduty.net/services/${serviceId}`,
        html_url: `https://pdt-mfich.pagerduty.net/services/${serviceId}`
      },
      assignments: [{
        at: '2019-05-10T23:19:15Z',
        assignee: {
          id: assignneId,
          type: 'user_reference',
          summary: 'Some User',
          self: `https://api.pagerduty.net/users/${assignneId}`,
          html_url: `https://pdt-mfich.pagerduty.net/users/${assignneId}`
        }
      }],
      last_status_change_at: '2019-05-10T23:19:15Z',
      first_trigger_log_entry: {
        id: 'RR9NFPZH02MHRPV330RNUPH18U',
        type: 'trigger_log_entry_reference',
        summary: 'Triggered through the website',
        self: 'https://api.pagerduty.net/log_entries/RR9NFPZH02MHRPV330RNUPH18U',
        html_url: `https://pdt-mfich.pagerduty.net/incidents/${incidentId}/log_entries/RR9NFPZH02MHRPV330RNUPH18U`
      },
      alert_counts: { all: 0, triggered: 0, resolved: 0 },
      is_mergeable: true,
      escalation_policy: {
        id: escalationPolicyId,
        type: 'escalation_policy_reference',
        summary: 'Default',
        self: `https://api.pagerduty.net/escalation_policies/${escalationPolicyId}`,
        html_url: `https://pdt-mfich.pagerduty.net/escalation_policies/${escalationPolicyId}`
      },
      teams: [],
      impacted_services: [{
        id: serviceId,
        type: 'service_reference',
        summary: 'Sample Notification Service',
        self: `https://api.pagerduty.net/services/${serviceId}`,
        html_url: `https://pdt-mfich.pagerduty.net/services/${serviceId}`
      }],
      pending_actions: [],
      acknowledgements: [],
      basic_alert_grouping: null,
      alert_grouping: null,
      last_status_change_by: {
        id: serviceId,
        type: 'service_reference',
        summary: 'Sample Notification Service',
        self: `https://api.pagerduty.net/services/${serviceId}`,
        html_url: `https://pdt-mfich.pagerduty.net/services/${serviceId}`
      },
      incidents_responders: [],
      responder_requests: [],
      subscriber_requests: [],
      urgency: 'high',
      id: incidentId,
      type: 'incident',
      summary: `[#1] ${params.title}`,
      self: `https://api.pagerduty.net/incidents/${incidentId}`,
      html_url: `https://pdt-mfich.pagerduty.net/incidents/${incidentId}`
    }
  };
};

export const incidentPostError = {
  error: {
    message: 'Invalid Input Provided',
    code: 2001,
    errors: ['Title cannot be empty.'],
  },
};

export default createIncidentData;
